// extracted by mini-css-extract-plugin
module.exports = {"button":"ReadMore_button_iIAVx","buttonContainer":"ReadMore_buttonContainer_as2xT"};